import React from 'react';
import Sidebar from './Menu';
import { includes } from 'lodash';
import { useLocation } from 'react-router-dom';

export const SidebarContext = React.createContext({});

const MainLayout = ({ children, showToggle }) => {
  const location = useLocation();
  const userRole = React.useMemo(
    () => JSON.parse(localStorage?.getItem('roles') || '[]'),
    []
  );

  // routes where sidebar should NOT show
  const noSidebarRoutes = React.useMemo(
    () => ['/map', '/incidents', '/map-history', '/control-room-chat','/view-control-room-chat'],
    []
  );

  const shouldShowSidebar =
    !includes(userRole, 'USER') &&
    !includes(userRole, 'ZONE HEAD') &&
    !noSidebarRoutes.includes(location.pathname);

  return (
    <div className='layout-container main-layout-wrapper'>
      {shouldShowSidebar && <Sidebar />}
      <SidebarContext.Provider value={{ showToggle }}>
        <div className='content-layout-wrapper__right'>{children}</div>
      </SidebarContext.Provider>
    </div>
  );
};

export default MainLayout;
